import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import PaginateList from "../../../utils/PaginateList";
import * as BatchServices from "../../../../services/BatchService";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ButtonAction, Icon } from "./batchList.styled";
import { Can, AbilityContext } from "../../../security/permissions/Can";
import {} from "../../../security/permissions/rolesPermission";
import {
  checkBootstrapSizeBreak,
  SIZES,
} from "../../../../utils/device/checkDevice";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";

const BatchListContainer = ({ filters, sortBy }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const deviceSize = checkBootstrapSizeBreak();
  const [forceRefresh, setForceRefresh] = useState(false);
  const context = useContext(AbilityContext);

  const columns = [
    {
      header: t("forms.batch.table.heads.code"),
      accessorKey: "code",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.batch.table.heads.active"),
      accessorKey: "active",
      cell: (info) => {
        if (info.getValue()) {
          return t("yes");
        }

        return t("no");
      },
    },
    {
      Header: " ",
      accessorKey: " ",
      cell: (info) => renderAction(info.row.original),
    },
  ];

  const goToEdit = (uuid) => {
    navigate(`/user/batch/form/update/${uuid}`);
  };

  const renderAction = (data) => {
    return (
      <div className="text-center">
        <ButtonAction onClick={() => goToEdit(data.uuid)} type="button">
          <i className="fa-regular fa-pen-to-square"></i>
        </ButtonAction>
        <ButtonAction
          onClick={() => showDialogOnDelete(data.uuid)}
          type="button"
        >
          <Icon className="fa-solid fa-trash-can"></Icon>
        </ButtonAction>
      </div>
    );
  };

  const showDialogOnDelete = (uuid) => {
    const okAction = async () => {
      BatchServices.deleteBatch(uuid).then((result) => {
        if (result && result.deleted === true) {
          setForceRefresh(true);
        }
      });
    };

    const cancelAction = () => {};

    ShowAlertDialog(
      t("forms.batch.dialog.remove.title"),
      t("forms.batch.dialog.remove.text"),
      "warning",
      true,
      t("forms.batch.dialog.remove.buttonOk"),
      false,
      okAction,
      t("forms.batch.dialog.remove.buttonNo"),
      cancelAction
    );
  };

  const listData = async (filter) => {
    // if (sortBy) {
    //   filter.sort = sortBy;
    // } else {
    //   filter.sort = "-date";
    // }
    const result = await BatchServices.listFilter(filter);
    return result;
  };

  const hideColumn = {};
  let resize = null;

  if (deviceSize < SIZES.md) {
    // hideColumn.itemCode = false;
    resize = false;
  } else if (deviceSize === SIZES.md) {
    // hideColumn.itemCode = false;
  }

  return (
    <PaginateList
      refresh={forceRefresh}
      filters={filters}
      columns={columns}
      toList={listData}
      hideColum={hideColumn}
      resize={resize}
      resetRefresh={() => setForceRefresh(false)}
    ></PaginateList>
  );
};

BatchListContainer.propTypes = {
  filters: PropTypes.object,
};

export default BatchListContainer;
